import type { ReactNode } from "react";
import { KeyLabel, KeyValueRow, Value } from "./timeReportDetailsPanel.styled";

interface DetailsRowProps {
  label: string;
  value: ReactNode;
}

export const DetailsRow = (props: DetailsRowProps): JSX.Element => {
  return (
    <KeyValueRow>
      <KeyLabel>{props.label}</KeyLabel>
      <Value>{props.value}</Value>
    </KeyValueRow>
  );
};
